import { Id, LaravelResponse, keyToUrl } from "@dgs/core";
import axios from "axios";

export interface YasumiProviderIndexResource {
	id: Id;
	label: string;
}

const baseKey = ["yasumi-providers"];

export const yasumiProviderService = {
	baseKey,
	index: (search: string, page: number) => {
		return axios.get<LaravelResponse<YasumiProviderIndexResource[]>>(keyToUrl(baseKey), {
			params: {
				search,
				page,
			},
		});
	},
};
